import {ReactElement} from "react";
import {forwardRef, InputHTMLAttributes} from "react";
import styled from "styled-components";

import {quicksandSemiBold} from "@/GlobalStyle";

type TextAreaProps = InputHTMLAttributes<HTMLTextAreaElement>;

const TextareaStyled = styled.textarea`
  & {
    width: calc(100% - 40px);
    padding: 10px 20px;
    border: 2px solid ${({theme}) => theme.colors.mediumSecondary};

    ${quicksandSemiBold};
    color: ${({theme}) => theme.colors.grey};
    &:active,
    &:focus {
      outline: 2px solid ${({theme}) => theme.colors.mediumSecondary};
    }
    &::placeholder {
      color: ${({theme}) => theme.colors.PlaceholderColor};
    }
  }
`;

export const Textarea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({...props}, ref): ReactElement => {
    return <TextareaStyled ref={ref} {...props} data-testid="InputStyled" />;
  }
);

type TextAreaLabelProps = TextAreaProps & {
  label?: string;
  isInColumn?: boolean;
};
const LabelStyled = styled.label`
  color: ${({theme}) => theme.colors.darkPrimary};
  ${quicksandSemiBold}
`;

const TextareaLabelContentStyled = styled.div<{$isInColumn: boolean}>`
  display: flex;
  flex-direction: ${({$isInColumn}) => ($isInColumn ? "column" : "row")};
  flex-wrap: wrap !important;
  padding: 10px 15px;
  gap: 15px;
  border-radius: 15px;
  justify-content: flex-start;
  align-items: ${({$isInColumn}) => ($isInColumn ? "flex-start" : "center")};

  &:hover,
  & label:hover,
  & Textarea:hover {
    cursor: pointer;
  }
`;

export const TextareaLabel = forwardRef<
  HTMLTextAreaElement,
  TextAreaLabelProps
>(({label, isInColumn = true, ...props}, ref): ReactElement => {
  return (
    <TextareaLabelContentStyled
      data-testid="TextareaLabelContentStyled"
      $isInColumn={isInColumn}>
      <LabelStyled htmlFor={props?.id}>{label}</LabelStyled>
      <TextareaStyled ref={ref} {...props} />
    </TextareaLabelContentStyled>
  );
});
